module.exports = __webpack_public_path__ + "static/media/giphy480p.04d13830.mp4";